module.exports = __webpack_public_path__ + "static/img/icon-1.1b8a86a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3/en/role-5/icon-1.png
// module id = T7y4
// module chunks = 0